import URL from "../../config/api";
import axios from "../../config/axios";

export const required = value => (value ? undefined : "Obrigatório");

const maxLength = max => value =>
  value && value.length > max
    ? `Este campo deve conter ${max} caracteres ou menos`
    : undefined;

export const minLength = min => value =>
  value && value.length < min
    ? `Este campo deve conter ${min} caracteres ou mais`
    : undefined;

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Email inválido"
    : undefined;

export const alphaNumeric = value =>
  value &&
  /[^a-zA-Z0-9-àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ ]/i.test(
    value
  )
    ? "Este campo deve conter apenas caracteres alfanuméricos"
    : undefined;

export const passwordsMustMatch = (value, allValues) =>
  value !== allValues.password ? "As senhas não coincidem" : undefined;

export const uniqueUsername = async (value, token) => {
  const res = await axios.get(
    `${URL.api}access/user/check?username=${value.username}`,
    { headers: { authorization: `Bearer ${token}` } }
  );

  return res.data === true ? { username: "Login já existe" } : undefined;
};

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? "Invalid phone number, must be 10 digits"
    : undefined;

export const max8 = maxLength(8);
export const max12 = maxLength(12);
export const min3 = minLength(3);
export const min8 = minLength(8);
export const min12 = minLength(12);
